import { IClientValidator } from "./IClientValidator.js";
import { ValidatorBase } from "./validator-base.js";

/// Works with StringLengthIfValueAttribute.cs to perform unobtrusive validation in MVC against
/// input fields that must have a maximum length but only if another field
/// has a specific value.
///
/// This is used on the order summary page for when a delivery address is
/// required but only if the delivery method is not collect in store.
export class StringLengthIfValue extends ValidatorBase implements IClientValidator {
    public validate(value: string, element: HTMLInputElement, params: any): boolean {
        let otherObj = this.elementByName(params.otherproperty);

        if (otherObj.value == null || otherObj.value == undefined || otherObj.value === '') {
            return true;
        }

        // Always compare as lowercase to catch True/true/TRUE etc.
        if (params.othervalue.toLowerCase() === otherObj.value.toLowerCase()) {
            if (element.value == null || element.value == undefined) {
                return true;
            }

            return element.value.length <= params.max;
        }

        return true;
    }
}

window.validators = window.validators || {};
window.validators.stringlengthifvalue = new StringLengthIfValue();
